import React, { useEffect, useRef, useState } from "react";
import { Box, Divider, Typography } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { StyledButton } from "../../../../../../shared/components/buttons/custom-button";
import CustomTable from "../../../../../../shared/components/table/custom-table";
import { ActionsMenu } from "../../../../../../shared/components/table/custom-actions";
import ActionsModalPopup, {
  ActionButtonConfig,
} from "../../../../../../shared/components/modals/action-popup";
import CustomStepper from "../../../../../../shared/components/stepper/steppers";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import {
  FloatingButtonContainer,
  InnerButton,
} from "../../../../../../shared/components/buttons/floating-button-container";
import FacilityInfoForm from "./facility-information";
import FacilityProcessInfo from "./facility-details";
import {
  FacilityFarmCapacityInformation,
  mapFacilityDetails,
  mapToFacilityDetailsDeteleSaveReq,
  mapToFacilityDetailsReq,
} from "../../../sc-models/facility-product-dto";
// import { SCAppConfig } from '../../../../../shared/app-configs/sc-app-config';
import { useApi } from "../../../../../../shared/hooks/useApi";
import useNotification from "../../../../../../shared/hooks/useNotification";
import { API_ROUTES } from "../../../../../../shared/app-configs/sc-app-config";
import { LoaderComponent } from "../../../../../../shared/components/loaders/page-loader";
import _ from "lodash";
import { useFormActions } from "../../../../../../shared/hooks/form-builder.hooks";
import AlertPopup from "../../../../../../shared/components/modals/alert-moadal";
import { Utills } from "../../../../../../shared/app-configs/utilit";
import RenderDetailPanel from "./render-detail-panel";
import {
  convertFacilityData,
  fetchFacilityDetails,
} from "./facility-setail-api";
import { useTransactionCertificateStore } from "../../../../../../store/transaction-certificates.store";
import { useScStore } from "../../../../../../store/scStandard.store";
import { FarmCategoryUtils } from "../../../constants/farm-categories";
import FacilityFarmCapacityInfo from "./facility-farm-capacity";

interface FacilityInformation {
  facilityId?: string;
  isMainSite: string;
  facilityNo?: string;
  facilityType: string;
  facilityOsId:string;
  facilityProductionCapacity?: number;
  facilityAdditionalScopes:string;
  facilityTeId?: string;
  facilityStandard?: string[];
  facilityName: string;
  facilityAddress1: string;
  facilityAddress2?: string;
  facilityAddress3?: string;
  facilityAddedDate:string;
  facilityRemovedDate?:string;
  facilityLastAuditDate?:string;
  facilityPostcode: string;
  facilityTown: string;
  facilityCountryOrArea: string;
  facilityStateOrProvince: string;
  facilityCbOfIndependentlyCertifiedSubcontractor: string;
}
export interface FacilityProcessDetails {
  facilityProcessCategoryCode: string;
  facilityProcessCategoryCodeDescription: string;
  facilityProcessCategoryUserSpecificTerm:string;
}
interface FacilityState {
  facilityInfo: FacilityInformation;
  facilityProcessInformation: FacilityProcessDetails[];
  facilityFarmCapacityInformation:FacilityFarmCapacityInformation[];
}

const initFacilityInfo: FacilityInformation = {
  isMainSite: "Y",
  // facilityNo: "",
  facilityType: "",
  facilityAdditionalScopes: "",
  facilityOsId: "",
  facilityAddedDate: "",
  facilityLastAuditDate: "",
  facilityRemovedDate: "",
  facilityProductionCapacity: undefined,
  facilityTeId: "",
  // brandNames: '',
  facilityStandard: [],
  facilityName: "",
  facilityAddress1: "",
  facilityAddress2: "",
  facilityAddress3: "",
  facilityPostcode: "",
  facilityTown: "",
  facilityCountryOrArea: "",
  facilityStateOrProvince: "",
  facilityCbOfIndependentlyCertifiedSubcontractor: "",
};

const initFacilityState: FacilityState = {
  facilityInfo: initFacilityInfo,
  facilityProcessInformation:  [],
  facilityFarmCapacityInformation:[]
};

interface ScopeCertifiedDetailsComponentProps {
  onNextTab: () => Promise<void>;
  scStatus?: boolean;
}

const ScopeCertifiedDetailsComponent: React.FC<
  ScopeCertifiedDetailsComponentProps
> = ({ onNextTab, scStatus }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [editingIndex, setEditingIndex] = useState<number>(-1);
  const [data, setData] = useState<FacilityState[]>([]);
  const [apiData, setAPIData] = useState<FacilityState[]>([]);
  const [mainFacility, setMainFacility] = useState<FacilityState | undefined>();
  const [tableData, setTableData] = useState<any[]>([]);
  const [facilityData, setFacilityData] =
    useState<FacilityState>(initFacilityState);
  const [isNextEnabled, setNextEnabled] = useState<boolean>(false);
  const [isDeleteOnly, setDeleteOnly] = useState(false);
  const { isRestrictPopUpSave } = useTransactionCertificateStore();
    const [isFarmSite,setIsFarmSite] = useState<boolean>(false);
  
  const navigate = useNavigate();
  const {
    apiData: shipmentData,
    loading,
    error,
    executeGet,
    setLoadingState,
    executePost,
    executeDelete,
  } = useApi();
  const { executeGet: executeNewGet, loading: loadingNewGet } = useApi();
  const { notify } = useNotification();
  const [getEditExistingFacilityDetails, setEditExistingFacilityDetails] =
    useState({
      index: -1,
      value: "",
    });
  const {
    getCurrentFormValues,
    getCurrentTableData,
    updateTableData,
    updateTableRowbyIndex,
    removeTableRowbyIndex,
    replaceTableDatas,
    updateField,
    setDeleteSave,
    setEditSave,
    resetFormValueByPage,
    getDeleteSave,
  } = useFormActions("sc-facilitydetails");
  const facilityInfoRef = useRef<any>(null);
  const facilityFarmCapacityInfoRef = useRef<any>(null);
  const rawMaterialRef = useRef<any>(null);
  const { formtype, SC_ID } = useParams();
  const hasCreateSC = formtype === "create-sc";
  const hasSubmitSC: boolean = formtype === "submited-sc";
  const isReadOnlyBasedOnStatus = hasSubmitSC || scStatus;
  const { scStandards, setScStandards, setScStandardDescriptions } = useScStore();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [popUpMessage, setPopUpMessage] = useState<string>("");
  const [popUpTitle, setPopUpTitle] = useState<string>("");
  const [popUpBtnName, setPopUpBtnName] = useState<string>("");
  const [facilityId, setFacilityId] = useState<string>("");
  // const [facilityNo, setFacilityNo] = useState<string>("");
  const [facilityTeId, setFacilityTeId] = useState<string>("");
  const [pendingSave, setPendingSave] = useState<any>(null);
  const [subsequentFacilityFlag, setSubsequentFacilityFlag] =
    useState<boolean>(false);
  const [scSubsequentFacilityButtonFlag, setScSubsequentFacilityButtonFlag] =
    useState<boolean>(true);
  const [scNoOfFarmsFlag, setScNoOfFarmsFlag] = useState<boolean>(false);
  
  // Helper function to check if any process category is a farm category
  const checkAndUpdateIsFarmSite = (processData: FacilityProcessDetails[]) => {
    const hasFarmCategory = processData.some((process) =>
      FarmCategoryUtils.isFarmCode(process?.facilityProcessCategoryCode)
    );
    setIsFarmSite(hasFarmCategory);
    return hasFarmCategory;
  };
  
  const setZustandInitialState = (initialState?: any) => {
    //set zustand state inital values
    const defaultState = initialState ?? initFacilityState;
    Object.entries(defaultState?.facilityInfo).forEach(([key, value]) => {
      updateField(key, value);
    });
    updateField("facilityProcessDetails", defaultState.facilityProcessDetails);
  };
  const loadFormData = async () => {
    try {
      if (scStandards.length === 0 && SC_ID) {
        try {
          const scResponse = await executeGet(API_ROUTES.GET_SC_DETAILS_V4, { scId: SC_ID });
          const standards = scResponse?.data?.scStandardInformation?.map(
            (item: any) => item.scStandard
          ) || [];
          setScStandards(standards);
          const descMap: Record<string, string> = {};
          (scResponse?.data?.scStandardInformation || []).forEach((item: any) => {
            if (item.scStandard && item.scStandardDescription) {
              descMap[item.scStandard] = item.scStandardDescription;
            }
          });
          setScStandardDescriptions(descMap);
        } catch (err) {
          console.error("Failed to fetch SC Details for standards:", err);
        }
      }

      const response: any = await executeGet(API_ROUTES.GET_FACILITY_LIST_DETAILS_V4, {
        scId: SC_ID,
      });
      const result = mapFacilityDetails(response.data.response);
      setTableData(result);
      setAPIData(result);
      setMainFacility(
        result?.find(
          (facility) => facility?.facilityInfo?.facilityType === "MF"
        )
      );
    } catch (err) {
      console.error("Failed to fetch TC Base Details:", err);
    }
  };

  useEffect(() => {
    if (SC_ID || !hasCreateSC) {
      loadFormData();
    } else {
      updateTableData([]);
    }
  }, [SC_ID]);

  const toggleDrawer = () => {
    if (drawerOpen) {
      resetForm();
      setFacilityData(initFacilityState);
      setZustandInitialState();
      setIsFarmSite(false);
      setFacilityId("");
      // setFacilityNo("");
      setEditingIndex(-1);
    } else {
      // Reset isFarmSite when opening drawer for new facility
      setIsFarmSite(false);
    }
    setActiveStep(0);
    setDrawerOpen((prev) => !prev);
  };

  const handleDataUpdate = (stepKey: keyof FacilityState, updatedData: any) => {
    setFacilityData((prev) => ({
      ...prev,
      [stepKey]: updatedData,
    }));
    
    // Check and update isFarmSite when process data changes
    if (stepKey === "facilityProcessInformation") {
      checkAndUpdateIsFarmSite(updatedData);
    }
  };
  const handleNext = async () => {
    const currentRef = (activeStep === 0) ? facilityInfoRef :(activeStep===1)?facilityFarmCapacityInfoRef: rawMaterialRef;
    Utills.cl("currentRef", currentRef);
    if (currentRef?.current ) {
      const formik = currentRef.current;
      // submitForm() always increments Formik's submitCount even when validation fails.
      // This is the trigger that makes hasError=true for all invalid fields (red highlight + error text).
      await formik.submitForm();
      const errors = await formik.validateForm();
      if (Object.keys(errors).length === 0) {
        setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
      } else {
        console.log("[Facility handleNext] Validation errors:", errors);
        notify("Please fill in all required fields before proceeding", "error");
      }
    } else if (activeStep===1){
        setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
    }
  };

  const handleBack = () => setActiveStep((prev) => Math.max(prev - 1, 0));
  Utills.cl(facilityData, "data", data);

  const handleFinish = async () => {
    if (facilityData.facilityProcessInformation.length <= 0) {
      notify("Please add atleast one facility process", "error");
      return;
    }
    
    // Only require farm capacity information for MF (Main Facility) or FA (Farm) facility types
    const facilityType = facilityData.facilityInfo.facilityType;
    const requiresFarmCapacity = facilityType === "MF" || facilityType === "FA";
    
    if (requiresFarmCapacity && isFarmSite && facilityData?.facilityFarmCapacityInformation?.length < 1) {
      notify("Please add facility farm capacity information", "error");
      return;
    }

    // B4: Duplicate TE-ID — no two facilities in the same SC may share a TE-ID
    const newTeId = facilityData.facilityInfo.facilityTeId?.trim();
    if (newTeId) {
      const duplicateTeId = tableData.find(
        (item: any) =>
          item.facilityInfo?.facilityTeId?.trim() === newTeId &&
          item.facilityInfo?.facilityId !== facilityId // exclude currently edited row
      );
      if (duplicateTeId) {
        notify(`A facility with TE-ID "${newTeId}" already exists in this Scope Certificate`, "error");
        return;
      }
    }

    // B5: Duplicate facility name — no two facilities in the same SC may share the same name
    const newFacilityName = facilityData.facilityInfo.facilityName?.trim();
    if (newFacilityName) {
      const duplicateName = tableData.find(
        (item: any) =>
          item.facilityInfo?.facilityName?.trim().toLowerCase() === newFacilityName.toLowerCase() &&
          item.facilityInfo?.facilityId !== facilityId // exclude currently edited row
      );
      if (duplicateName) {
        notify(`A facility named "${newFacilityName}" already exists in this Scope Certificate`, "error");
        return;
      }
    }

    if (SC_ID) {
      // Find the existing record in tableData that matches the facilityId
      const existingRecord = tableData.find(
        (item) => item.facilityInfo.facilityId === facilityId
      );
      let payloadFacilityId: string | null = facilityId;
      if (
        existingRecord &&
        existingRecord.facilityInfo.facilityTeId !==
          facilityData?.facilityInfo?.facilityTeId
      ) {
        payloadFacilityId = null;
      }
      const payload = mapToFacilityDetailsReq(facilityData, SC_ID, facilityId);
      // Check if facilityNo exists and has changed
      if (facilityId) {
        // If record exists and facilityNo has changed, handle deletion
        if (
          existingRecord
          &&
          existingRecord.facilityInfo.facilityTeId !==
            payload.facilityTeId
        ) {
          const row = {
            original: {
              facilityInfo: {
                facilityTeId:payload?.facilityTeId,
                // facilityNo: payload.facilityNo,
                facilityId: facilityId,
              },
            },
          };

          onEditDelete(row);
          // The actual save will happen in handleConfirmSave after deletion
          setPendingSave(payload);
          return;
        }

        // If no changes to facility number, save directly
        handleSave(payload);
      } else if (!facilityId) {
        // This is a new facility, not an edit
        handleSave(payload);
      }
    }
  };

  // Compute if Facility Production Capacity is required based on selected process codes
  const isProdCapacityRequiredFor = (processCodes: string[]): boolean => {
    const codeSet = new Set(processCodes || []);
    const farmCodes = FarmCategoryUtils.getFarmCodesSet();
    const supplyChainCodes = FarmCategoryUtils.getSupplyChainCodesSet();
    const exemptComboCodes = FarmCategoryUtils.getExemptComboCodesSet();

    // Only farm codes -> optional
    if ([...codeSet].length > 0 && [...codeSet].every((c) => farmCodes.has(c))) return false;
    // Only supply chain codes -> optional
    if ([...codeSet].length > 0 && [...codeSet].every((c) => supplyChainCodes.has(c))) return false;
    // Only exempt combo codes -> optional
    if ([...codeSet].length > 0 && [...codeSet].every((c) => exemptComboCodes.has(c))) return false;

    const hasFarmCode = [...codeSet].some((c) => farmCodes.has(c));
    const hasNonExemptOtherCode = [...codeSet].some((c) => !farmCodes.has(c) && !exemptComboCodes.has(c));

    // Farm + any other (non-exempt) code -> mandatory
    if (hasFarmCode && hasNonExemptOtherCode) return true;

    // Default -> optional
    return false;
  };

  // Validate conditional rules before POST; notify each failure and block save.
  // currentFacilityId: the ID of the facility currently being edited (from state).
  // This is the authoritative exclusion key — do NOT rely on info?.facilityId which
  // may be empty if the single-facility API maps the field under a different name.
  const validateBeforePost = (state: FacilityState, currentFacilityId?: string): boolean => {
    const info = state?.facilityInfo || ({} as any);
    const processCodes = (state?.facilityProcessInformation || []).map((p) => p?.facilityProcessCategoryCode);
    // Use the passed-in ID first; fall back to whatever the mapped data has
    const excludeId = currentFacilityId || info?.facilityId || "";
    let valid = true;

    // Duplicate TE-ID check — skip if we're editing the facility that owns this TE-ID
    if (info?.facilityTeId) {
      const duplicateTeId = apiData.find((facility: any) =>
        facility?.facilityInfo?.facilityTeId === info.facilityTeId &&
        (excludeId ? facility?.facilityInfo?.facilityId !== excludeId : true)
      );
      if (duplicateTeId) {
        notify(`Facility with TE-ID ${info.facilityTeId} already exists in this SC`, "error");
        valid = false;
      }
    }

    // Duplicate Name check — skip if we're editing the facility that owns this name
    if (info?.facilityName) {
      const duplicateName = apiData.find((facility: any) =>
        facility?.facilityInfo?.facilityName?.trim()?.toLowerCase() === info.facilityName?.trim()?.toLowerCase() &&
        (excludeId ? facility?.facilityInfo?.facilityId !== excludeId : true)
      );
      if (duplicateName) {
        notify(`Facility with Name ${info.facilityName} already exists in this SC`, "error");
        valid = false;
      }
    }

    // Facility Town mandatory
    if (!info?.facilityTown || String(info.facilityTown).trim() === "") {
      notify("Facility Town is required", "error");
      valid = false;
    }

    // Facility Production Capacity conditional
    if (isProdCapacityRequiredFor(processCodes)) {
      if (!info?.facilityProductionCapacity || String(info.facilityProductionCapacity).trim() === "") {
        notify("Facility Production Capacity is required", "error");
        valid = false;
      }
    }

    // CB of Independently Certified Subcontractor for CS
    if (info?.facilityType === "CS") {
      if (!info?.facilityCbOfIndependentlyCertifiedSubcontractor || String(info.facilityCbOfIndependentlyCertifiedSubcontractor).trim() === "") {
        notify("CB of Independently Certified Subcontractor is required", "error");
        valid = false;
      }
    }

    // Facility Last Audit Date required for MF, FA, AS
    if (["MF", "FA", "AS"].includes(info?.facilityType)) {
      if (!info?.facilityLastAuditDate || String(info.facilityLastAuditDate).trim() === "") {
        notify("Facility Last Audit Date is required", "error");
        valid = false;
      }
    }

    // Farm Capacity required for MF/FA with specific process codes
    const farmCapacityRequiredProcessCodes = ['PR0011', 'PR0036', 'PR0037', 'PR0038'];
    if (info?.facilityType === 'MF' || info?.facilityType === 'FA') {
      const requiresFarmCapacity = processCodes.some(code => farmCapacityRequiredProcessCodes.includes(code));
      if (requiresFarmCapacity) {
        if (!state.facilityFarmCapacityInformation || state.facilityFarmCapacityInformation.length === 0) {
          notify("Facility Farm Capacity Information is required for the selected facility type and process codes", "error");
          valid = false;
        }
      }
    }

    // Process Category Code Standard Validations (Rule 6)
    if (scNoOfFarmsFlag && info?.facilityStandard) {
      const standards = Array.isArray(info.facilityStandard) ? info.facilityStandard : [info.facilityStandard];
      
      // RAF (RWS, RMS, RAS) validation
      if (standards.some((s: string) => ["RWS", "RMS", "RAS"].includes(s))) {
        if (!processCodes.some(code => ["PR0011", "PR0036", "PR0038"].includes(code))) {
          notify("For RAF standards, at least one of PR0011, PR0036, or PR0038 must be selected.", "error");
          valid = false;
        }
      }

      // RDS validation
      if (standards.includes("RDS")) {
        if (!processCodes.some(code => ["PR0011", "PR0037"].includes(code))) {
          notify("For RDS standard, at least one of PR0011 or PR0037 must be selected.", "error");
          valid = false;
        }
      }

      // MMS validation
      if (standards.includes("MMS")) {
        if (processCodes.includes("PR0037")) {
          notify("For MMS standard, PR0037 is not allowed.", "error");
          valid = false;
        }
        if (!processCodes.some(code => ["PR0011", "PR0036", "PR0038"].includes(code))) {
          notify("For MMS standard, at least one of PR0011, PR0036, or PR0038 must be selected.", "error");
          valid = false;
        }
      }
    }

    return valid;
  };

  const handleSave = async (payload: any) => {
    if (!SC_ID) {
      return;
    }
    // Pre-POST validation: block API call if conditional rules not satisfied.
    // Pass facilityId state as currentFacilityId so the exclusion check uses
    // the correct ID regardless of how the single-facility API maps the field.
    if (!validateBeforePost(facilityData, facilityId)) {
      return false;
    }
    let isSuccess = false;
    const queryParams = new URLSearchParams({
      scId: SC_ID,
    }).toString();

    const finalUrl = `${API_ROUTES.CREATE_FACILITY_DETAILS_V4}?${queryParams}`;

    const result: any = await executePost(finalUrl, payload);
    if (result?.status === 200) {
      isSuccess = true;
      notify("Data Saved Successfully", "success");
      setFacilityId("");
      // setFacilityNo("");
      loadFormData();
      setFacilityData(initFacilityState);
      toggleDrawer();
      await onNextTab();
    } else {
      notify("Unable to Save", "error");
    }
    return isSuccess;
  };

  const handleConfirmSave = async () => {
    try {
      // If we have a pending save payload, save it now
      let isSaveSuccess: any = false;
      if (pendingSave) {
        delete pendingSave.facilityId;
        isSaveSuccess = await handleSave(pendingSave);
        setPendingSave(null); // Clear the pending save
      }
      if (!pendingSave || isSaveSuccess) {
        await executeDelete(`${API_ROUTES.DELETE_API_V4}`, {
          scId: SC_ID,
          facilityId: facilityId,
          facilityTeId: facilityTeId,
        });

        await loadFormData();

        // Close the dialog
        setDialogOpen(false);

        // Reset states
        setFacilityId("");
        setFacilityTeId("");
        if (pendingSave) {
          notify("Previous facility successfully deleted", "success");
        } else {
          notify("Successfully deleted", "success");
        }
      }
    } catch (error) {
      console.error("Error in handleConfirmSave:", error);
      notify("Failed to process the request", "error");
    }
  };

  const onNext = () => {
    if (
      apiData.filter(
        (facility) => facility?.facilityInfo?.facilityType === "MF"
      ).length == 0
    ) {
      notify("Please add atleast one Main Facility", "error");
    } else {
      navigate(`/v4/sc/${formtype}/product-category-information/${SC_ID}`);
    }
  };

  const handleDeleteSaveData = async () => {
    try {
      if (SC_ID) {
        if (!isDeleteOnly && getDeleteSave()) {
          const userFilledValues = getCurrentFormValues();
          updateTableRowbyIndex(editingIndex, userFilledValues);
        } else if (isDeleteOnly && !getDeleteSave()) {
          removeTableRowbyIndex(editingIndex);
          const deletedData = data.filter((item, index) => {
            index !== editingIndex;
          });
          setData(deletedData);
          setEditingIndex(-1);
        }
        const facilityDetailsData: any = getCurrentTableData();
        setDeleteOnly(false);
        setDeleteSave(false);
        setEditSave(false);
        let isPostCreation = apiData?.length === 1 ? "no" : "yes";
        const facilityDetailsReq = mapToFacilityDetailsReq(
          data,
          SC_ID,
          isPostCreation
        );
        const result: any = await executePost(
          API_ROUTES.CREATE_FACILITY_DETAILS,
          facilityDetailsReq
        );
        if (result?.status === 200) {
          notify("Saved Successfully", "success");
          // toggleDrawer()
          await loadFormData();
        } else {
          notify("Unable to Save", "error");
        }
      }
    } catch (error) {
      console.error("Error saving Facility Details:", error);
      notify("Error saving Facility Details", "error");
    }
  };
  const handleCancelSave = async () => {
    // Utills.cl("inside handleCancelSave", getDeleteSave())
    // if (!isDeleteOnly) {
    //   // toggleDrawer()
    // }
    // if (getEditExistingFacilityDetails.index != -1) {
    //   setEditExistingFacilityDetails({
    //     index: -1, value: ''
    //   })
    //   toggleDrawer()
    // }
    // setDeleteSave(false)
    // await loadFormData()
    setDialogOpen(false);
    if (drawerOpen) {
      toggleDrawer();
    }
  };
  const onEdit = (row: any) => {
    const value = row?.original;
    setFacilityId(value.facilityInfo.facilityId);
    setFacilityTeId(row?.original?.facilityInfo?.facilityTeId);
    // setFacilityNo(value.facilityInfo.facilityNo);
    if (SC_ID && value.facilityInfo.facilityId) {
      fetchFacilityDetails(executeNewGet, SC_ID, value.facilityInfo.facilityId)
        .then((data:any) => {
          const payload = convertFacilityData(data?.data);
          setFacilityData(payload);
          // Initialize isFarmSite based on existing process data
          checkAndUpdateIsFarmSite(payload.facilityProcessInformation || []);
          toggleDrawer();
        })
        .catch((err:any) => notify(err.message, "error"));
    }

    setEditingIndex(row.index);
    setZustandInitialState(value);
  };

  const onDelete = (row: any) => {
    setFacilityId(row?.original?.facilityInfo.facilityId);
    // setFacilityNo(row?.original?.facilityInfo.facilityNo);
    setFacilityTeId(row?.original?.facilityInfo?.facilityTeId);
    setDialogOpen(true);
    setPopUpBtnName("Delete");
    setPopUpTitle("Confirm Delete ?");
    setPopUpMessage(
      `Deleting a Facility will remove all the Associated Records, are you sure want to delete it`
    );
  };

  const onEditDelete = (row: any) => {
    setFacilityId(row?.original?.facilityInfo.facilityId);
    setFacilityTeId(row?.original?.facilityInfo?.facilityTeId);
    // setFacilityNo(row?.original?.facilityInfo.facilityNo);
    setDialogOpen(true);
    setPopUpBtnName("Save");
    setPopUpTitle("Confirm Save ?");
    setPopUpMessage(
      `Editing a Facility No. will remove all the Associated Facility Products, are you sure want to edit it`
    );
  };

  const resetForm = () => {
    setZustandInitialState(initFacilityState);
  };
  const steps = [
    {
      label: "Facility Information",
      content: (
        <FacilityInfoForm
          formRef={facilityInfoRef}
          facilityData={facilityData.facilityInfo}
          mainSite={mainFacility}
          mfExists={
            apiData.length > 0 &&
            apiData.filter(
              (facility) => facility?.facilityInfo?.facilityType === "MF"
            ).length > 0
          }
          isEditing={!!facilityId}
          processCodes={facilityData.facilityProcessInformation?.map((process)=>process?.facilityProcessCategoryCode)}
          setFacilityData={(data:any) => handleDataUpdate("facilityInfo", data)}
          setSubsequentFacilityFlag={setSubsequentFacilityFlag}
          subsequentFacilityFlag={subsequentFacilityFlag}
          setScSubsequentFacilityButtonFlag={setScSubsequentFacilityButtonFlag}
          // scNoOfFarmsFlag={scNoOfFarmsFlag}
          // setScNoOfFarmsFlag={setScNoOfFarmsFlag}
          scSubsequentFacilityButtonFlag={scSubsequentFacilityButtonFlag}
          facilityInfoData={facilityData.facilityProcessInformation}
        />
      ),
    },
    {
      label: "Facility Process Information",
      content: (
        <FacilityProcessInfo
          // formRef={rawMaterialRef}
          facilityData={facilityData.facilityInfo}
          facilityProcessInfo={facilityData.facilityProcessInformation}
          facilityFarmCapacityInfo={facilityData.facilityFarmCapacityInformation}
          setFacilityProcessInfo={(data:any) =>
            handleDataUpdate("facilityProcessInformation", data)
          }
          setIsFarmSite={setIsFarmSite}
          isFarmSite={isFarmSite}
          subsequentFacilityFlag={subsequentFacilityFlag}
          setSubsequentFacilityFlag={setSubsequentFacilityFlag}
          scSubsequentFacilityButtonFlag={scSubsequentFacilityButtonFlag}
          setScSubsequentFacilityButtonFlag={setScSubsequentFacilityButtonFlag}
          scNoOfFarmsFlag={scNoOfFarmsFlag}
          setScNoOfFarmsFlag={setScNoOfFarmsFlag}
        />
      ),
    },
    // Show farm capacity step for MF or FA facility type when isFarmSite is true
    ...(isFarmSite && ["MF", "FA"].includes(facilityData?.facilityInfo?.facilityType)) ? [{
      label: "Facility Farm Capacity Information",
      content: (
        <FacilityFarmCapacityInfo
          formRef={facilityFarmCapacityInfoRef}
          facilityData={facilityData.facilityInfo}
          facilityFarmCapacityInfo={facilityData.facilityFarmCapacityInformation}
          facilityStandard={facilityData.facilityInfo?.facilityStandard || []}
          facilityProcessInfo={facilityData.facilityProcessInformation}
          setScSubsequentFacilityButtonFlag={setScSubsequentFacilityButtonFlag}
          setFacilityFarmCapacityInfo={(data:any) =>
            handleDataUpdate("facilityFarmCapacityInformation", data)
          }
        />
      ),
    }] : [],
  ];

  const actions: ActionButtonConfig[] = [
    ...activeStep!==0?[{
      label: "Back",
      onClick: handleBack,
      variant: "contained" as "contained",
      color: "default" as const,
      disabled: activeStep === 0,
    }]:[],
    {
      label: activeStep === steps.length - 1 ? "Save" : "Next",
      onClick: activeStep === steps.length - 1 ? handleFinish : handleNext,
      variant: "contained",
      color: "primary",
      disabled: ((activeStep === 1||activeStep === 2) && isRestrictPopUpSave) ||
        (activeStep === 2 && !scSubsequentFacilityButtonFlag),
    },
  ];

  const columns: MRT_ColumnDef<FacilityInformation>[] = [
    // {
    //   accessorKey: "facilityInfo.facilityNo",
    //   header: "Facility No.",
    //   minSize: 60,
    //   maxSize: 150,
    // },
    {
      accessorKey: "facilityInfo.facilityType",
      header: "Facility Type",
      minSize: 60,
      maxSize: 150,
    },
    // {
    //   accessorKey: "facilityInfo.facilityOarId",
    //   header: "OAR ID",
    //   minSize: 60,
    //   maxSize: 150,
    // },
    {
      accessorKey: "facilityInfo.facilityTeId",
      header: "Facility TE-ID",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "facilityInfo.facilityName",
      header: "Facility Name",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "facilityInfo.facilityPostcode",
      header: "Postcode",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "facilityInfo.facilityCountryOrArea",
      header: "Country/Area",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "facilityInfo.facilityAddedDate",
      header: "Facility Added Date",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "facilityInfo.facilityRemovedDate",
      header: "Facility Removed Date",
      minSize: 60,
      maxSize: 150,
    },
  ];
  console.log(tableData);
  return (
    <>
      {loading ? (
        <LoaderComponent />
      ) : (
        <>
          <Box display="flex" mb={3} justifyContent="flex-end" width="100%">
            {!isReadOnlyBasedOnStatus && (
              <StyledButton
                variant="contained"
                onClick={() => {
                  if (
                    apiData?.length === 0 ||
                    apiData.filter(
                      (facility) =>
                        facility?.facilityInfo?.facilityType === "MF"
                    ).length == 0
                  ) {
                    setFacilityData({
                      ...initFacilityState,
                      facilityInfo: {
                        ...initFacilityInfo,
                        facilityType: "MF",
                      },
                    });
                  }
                  toggleDrawer();
                }}
              >
                Add New Facility
              </StyledButton>
            )}
          </Box>
          <Box display="grid">
            <CustomTable
              columns={columns}
              data={tableData}
              enableTopToolbar={false}
              enableBottomToolbar={true}
              enableRowActions={!isReadOnlyBasedOnStatus}
              renderDetailPanel={({ row }:any) =>
                // Only mount the detail panel if the row is expanded
                row.getIsExpanded() ? (
                  <RenderDetailPanel row={row} />
                ) : (
                  <>No data</>
                )
              }
              renderRowActions={({ row }:any) => (
                <ActionsMenu row={row} onEdit={onEdit} onDelete={onDelete} />
              )}
            />
          </Box>
          <ActionsModalPopup
            open={drawerOpen}
            onClose={toggleDrawer}
            title="Add Facility"
            actions={actions}
          >
            <CustomStepper
              steps={steps}
              activeStep={activeStep}
              onStepChange={(step:any) => setActiveStep(step)}
            />
          </ActionsModalPopup>
          {tableData.length > 0 && !drawerOpen && (
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2, gap:"0.5rem" }}>
              {/* <InnerButton onClick={handleSave}>Save & Next</InnerButton> */}
              <NavLink to="/v4/sc-dashboard">
                <InnerButton>Home</InnerButton>
              </NavLink>
              <InnerButton onClick={onNext}>Next</InnerButton>
            </Box>
          )}
          <AlertPopup
            open={dialogOpen}
            title={popUpTitle}
            message={popUpMessage}
            onClose={handleCancelSave}
            onConfirm={handleConfirmSave}
            confirmText={popUpBtnName}
            cancelText="Cancel"
          />
        </>
      )}
    </>
  );
};

export default ScopeCertifiedDetailsComponent;
